import React from "react";
import moment from "moment";
import Ordered from "./SVGS/Ordered";
import OrderReady from "./SVGS/OrderReady";
import InTransit from "./SVGS/InTransit";
import OutForDelivery from "./SVGS/OutForDelivery";
import Delivered from "./SVGS/Delivered";
// import Skeletion from "./common/Skeletion";
import "../scss/progressbar.scss";
import { useSelector } from "react-redux";

const ProgressBarMobile = ({ src, order }) => {
  // const customStatusIcons = [
  //   custom_1,
  //   custom_2,
  //   custom_3,
  //   custom_4,
  //   custom_5,
  // ];

  const {
    tracking_summary,
    tracking_manual,
    created_at,
    tracking_detail: logs,
  } = order;
  const history = logs ? logs : [];
  const trackingInfo = order;
  const {
    trackingStatus: i18n,
    customStatus,
    general: generalSettings,
  } = useSelector((state) => state.settings);
  const { progress_bar } = useSelector((state) => state.i18n);

  const checkOrderNoInfo = () => {
    if (
      (tracking_summary === "courier_not_supported" &&
        tracking_manual === "courier_not_supported") ||
      (tracking_summary === "courier_not_supported" && !tracking_manual)
    ) {
      return true;
    }
    return false;
  };

  const trackingStatus =
    tracking_summary === "courier_not_supported"
      ? tracking_manual ?? tracking_summary
      : tracking_summary;

  const listStatus = {
    courier_not_supported: 0,
    information_received: 2, // đổi từ 1 thành 2 để fix bug
    pending: 1,
    available_for_pickup: 2,
    in_transit: 3,
    failed_attempt: 4,
    exception: 4,
    expired: 4,
    out_for_delivery: 4,
    delivered: 5,
  };

  const activeIndex = listStatus[trackingStatus] ?? null;
  const re = new RegExp("_", "g");
  const isActiveCustomStatus =
    Math.abs(moment(created_at).diff(moment(), "days")) >=
    +customStatus.timeActive;

  let status;
  if (activeIndex === null) {
    if (customStatus.enabled && isActiveCustomStatus) {
      status = customStatus.label;
    } else {
      status = i18n.ordered;
    }
  } else {
    status = i18n[trackingStatus];
  }

  const detectStatus = () => {
    if (customStatus.enabled == 1 || customStatus.enabled == true) {
      switch (tracking_summary) {
        case "pending":
          return 0;
        case "courier_not_supported":
          return 10;
        case "available_for_pickup":
        case "information_received":
          return 49.98;
        case "in_transit":
          return 66.64;
        case "out_for_delivery":
          return 83.3;
        case "failed_attempt":
        case "exception":
        case "expired":
          return 90;
        case "delivered":
          return 100;
        default:
          break;
      }
    } else {
      switch (tracking_summary) {
        case "pending":
          return 0;
        case "courier_not_supported":
          return 20;
        case "available_for_pickup":
        case "information_received":
          return 40;
        case "in_transit":
          return 60;
        case "out_for_delivery":
          return 80;
        case "failed_attempt":
        case "exception":
        case "expired":
          return 90;
        case "delivered":
          return 100;
        default:
          break;
      }
    }
  };

  return (
    <div className="omg-progress-bar-mobile">
      <div>
        {trackingInfo && (
          <div
            className="sm:shadow sm:rounded mb-6 bg-white"
            style={{
              overflow: "hidden",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div>
              <div className="tracking_order_now_content">
                <div className="tracking_order_now_result_template">
                  <div className="progress-bar-mobile-style">
                    <div
                      className="progress-bar-mobile-left"
                      style={{ height: `calc(${detectStatus()}% - 80px)` }}
                    ></div>
                    <span className="progress-bar-mobile-left-disabled" />
                    <div className="progress-bar-mobile-list">
                      <span className={`node-active`} />
                      <div className="omg-progress-bar-mobile-info">
                        <Ordered />
                        <div className="progress-bar-mobile-content">
                          <b className="ordered-status">{i18n.ordered}</b>{" "}
                          <span className="ordered_time">
                            (
                            {moment(created_at).format(
                              generalSettings.dateFormat
                            )}
                            )
                          </span>
                          {/* <div className="omg-time">
                            <div className="omg-time__minor">
                              {moment(created_at).format(
                                generalSettings.dateFormat
                              )}
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    {(customStatus?.enabled === 1 ||
                      customStatus?.enabled === true) && (
                      <div className="progress-bar-mobile-list">
                        <span
                          className={`${
                            activeIndex >= 2 && "node-active"
                          } progress-bar-mobile-node`}
                        />
                        <div className="omg-progress-bar-mobile-info">
                          <img
                            src={src}
                            alt="ordered"
                            width="32px"
                            height="32px"
                          />
                          <div className="progress-bar-mobile-content">
                            <b className="order-ready-status">
                              {customStatus.label}
                            </b>
                            <span className="ordered_ready_time">
                              {" "}
                              {`(${moment(created_at)
                                .add(customStatus.timeActive, "days")
                                .format(generalSettings.dateFormat)})`}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="progress-bar-mobile-list">
                      <span
                        className={`${
                          activeIndex >= 2 && "node-active"
                        } progress-bar-mobile-node`}
                      />
                      <div className="omg-progress-bar-mobile-info">
                        <OrderReady />
                        <div className="progress-bar-mobile-content">
                          <b className="order-ready-status">
                            {i18n.information_received}
                          </b>
                          <span className="ordered_ready_time">
                            {" "}
                            {activeIndex >= 1 && history[history?.length - 1]
                              ? `(${moment(
                                  history[history?.length - 1].date_time
                                ).format(generalSettings.dateFormat)})`
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="progress-bar-mobile-list">
                      <span
                        className={`${
                          activeIndex >= 3 && "node-active"
                        } progress-bar-mobile-node`}
                      />
                      <div className="omg-progress-bar-mobile-info">
                        <InTransit />
                        <div className="progress-bar-mobile-content">
                          <b className="in-transit-status">{i18n.in_transit}</b>
                          <span className="in_transit_time">
                            {" "}
                            {activeIndex >= 3 && history[history?.length - 2]
                              ? `(${moment(
                                  history[history?.length - 2].date_time
                                ).format(generalSettings.dateFormat)})`
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="progress-bar-mobile-list progress-bar-mobile-disabled">
                      <span
                        className={`${
                          activeIndex >= 4 && "node-active"
                        } progress-bar-mobile-node`}
                      />
                      <div className="omg-progress-bar-mobile-info">
                        <OutForDelivery />
                        <div className="progress-bar-mobile-content">
                          <b className="out-for-delivery-status">
                            {i18n.out_for_delivery}
                          </b>
                          <span className="out_of_delivery_time">
                            {" "}
                            {activeIndex >= 4 && history[1]
                              ? `(${moment(history[1].date_time).format(
                                  generalSettings.dateFormat
                                )})`
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="progress-bar-mobile-list progress-bar-mobile-disabled">
                      <span
                        className={`${
                          activeIndex >= 5 && "node-active"
                        } progress-bar-mobile-node`}
                      />
                      <div className="omg-progress-bar-mobile-info">
                        <Delivered />
                        <div className="progress-bar-mobile-content">
                          <b className="delivered-status">{i18n.delivered}</b>
                          <span className="delivered_time">
                            {" "}
                            {detectStatus() === 100 &&
                              history[0] &&
                              `(${moment(history[0].date_time).format(
                                generalSettings.dateFormat
                              )})`}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style={{ clear: "both" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBarMobile;
